<script>
class FixedQueue {
    constructor(maxSize) {
        this.contents = [];
        this.maxSize = maxSize;
    }

    clear() {
        this.contents = [];
    }

    push(val) {
        // check if queue is full
        if (this.contents.length === this.maxSize) {
            this.contents.shift();
        }
        this.contents.push(val);
    }
}

export default {
    name: 'AssetDashboardDebug',
    data() {
        return {
            // show debug logs
            isLogsShow: false,

            // queue to hold latest 10 events
            assetEventsLog: new FixedQueue(10),

            // debug table
            debugTablePagination: {
                sortBy: 'date',
                descending: true,
                page: 1,
                rowsPerPage: 10
            },
            debugAssetTableColumns: [
                {
                    name: 'date',
                    label: 'Date',
                    required: true,
                    align: 'left',
                    field: row => row.timestamp,
                    sortable: true
                },
                {
                    name: 'receivedAt',
                    label: 'Received At',
                    required: true,
                    align: 'left',
                    field: row => row.receivedAt,
                    sortable: true
                },
                {
                    name: 'delay',
                    label: 'Delay',
                    required: true,
                    align: 'left',
                    field: row => row.delay,
                    sortable: true
                }
            ],
            // summary statistics
            debugStats: {
                asset: {
                    nbEvents: 0,
                    minDelay: Infinity,
                    maxDelay: -Infinity,
                    avgDelay: null,
                    avgDiff: 0,
                    minDiff: 0,
                    maxDiff: 0
                }
            }
        };
    },
    methods: {
        /**
         * Reset the running statistics about data streaming.
         */
        resetStats() {
            this.debugStats = {
                asset: {
                    nbEvents: 0,
                    minDelay: Infinity,
                    maxDelay: -Infinity,
                    avgDelay: null,
                    avgDiff: 0,
                    minDiff: 0,
                    maxDiff: 0
                }
            };
        },
        /**
         * Update debug stats.
         * @param {Object} event
         * @param {String} sensorType - Update events log for sensor type.
         */
        updateStats(event, sensorType) {
            // calculate the delay stats
            const delay = event.delay;
            if (delay < this.debugStats[sensorType]['minDelay']) {
                this.debugStats[sensorType]['minDelay'] = delay;
            }
            if (delay > this.debugStats[sensorType]['maxDelay']) {
                this.debugStats[sensorType]['maxDelay'] = delay;
            }

            // calculate running average
            let eventLogs = null;
            if (sensorType === 'asset') {
                eventLogs = this.assetEventsLog;
            }

            // calculate delays
            let totalDelay = 0;
            let eventCount = 0;
            for (const event of eventLogs.contents) {
                totalDelay += event['delay'];
                eventCount += 1;
            }
            const avgDelay = totalDelay / eventCount;
            this.debugStats[sensorType]['avgDelay'] = avgDelay.toFixed(4);

            // increase events count
            this.debugStats[sensorType]['nbEvents'] += 1;
        }
    }
};
</script>
